// extracted by mini-css-extract-plugin
export default {"group":"ApprovalDetailsForm_group__JlUI0","dueDate":"ApprovalDetailsForm_dueDate__r5ciB","label":"ApprovalDetailsForm_label__YN-al","footer":"ApprovalDetailsForm_footer__+Xr4E"};